<template>
    <clockForm></clockForm>
</template>

<script>
import clockForm from './form'
export default {
    components: {
        clockForm
    }
}
</script>